<template>
  <v-os-popup title="请选择取件时间" v-model="show" @close="close" container="body" :maxHeightFill="true">
    <div class="date-time-selector" :class="{ 'custom-dark': customDark }">
      <div class="date-columns" role="tablist">
        <div
          v-for="(date, index) in dates"
          :class="['date-item', index == selectedDateIndex ? 'active' : '']"
          :key="index"
          role="tab"
          @click="selectDate(index)"
          :aria-selected="index == selectedDateIndex ? 'true' : 'false'"
        >
          <span v-if="date.doorLabel" class="label">{{ date.doorLabel }}</span>
          <span class="date">{{ date.doorDate | formateDate }}</span>
        </div>
      </div>
      <div class="time-columns" role="listbox" ref="timesRef">
        <div
          v-for="(time, j_index) in times"
          role="option"
          class="time-item"
          :key="j_index"
          @click="selectTime(time, j_index)"
          :aria-selected="j_index == selectTimeIndex ? 'true' : 'false'"
        >
          <span :aria-label="time.startTim + '到' + time.endTime">{{ time.startTime }} - {{ time.endTime }}</span>
          <v-checkbox class="checkbox" :value="true" v-if="j_index == selectTimeIndex"></v-checkbox>
        </div>
      </div>
    </div>
  </v-os-popup>
</template>
<script>
export default {
  name: 'PickUpTimePopUp',
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          isShow: false,
          dates: [],
          selected: ''
        }
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    customDark: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formateDate(date) {
      const arr = date.split('-')
      return arr[1] + '月' + arr[2] + '日'
    }
  },
  computed: {
    dates() {
      return this.info?.dates || []
    },
    times() {
      return this.dates[this.selectedDateIndex]?.doorTimeList || []
    }
  },
  watch: {
    show(val) {
      if (val) {
        if (!this.info?.selected) {
          this.selectedDateIndex = 0
          this.selectTimeIndex = -1
          return
        }
        const startDateAndTime = this.info.selected.split(',')[0]
        if (!startDateAndTime) {
          this.selectedDateIndex = 0
          this.selectTimeIndex = -1
          return
        }
        const endDateAndTime = this.info.selected.split(',')[1]
        const selectedDateStr = startDateAndTime.split(' ')[0]
        const index = this.dates.findIndex(item => item.doorDate == selectedDateStr)
        this.selectedDateIndex = Math.max(index, 0)
        const time = this.dates[this.selectedDateIndex].doorTimeList || []
        this.selectTimeIndex = time.findIndex(
          item => item.startTime == startDateAndTime.split(' ')[1] && item.endTime == endDateAndTime.split(' ')[1]
        )
      }
    }
  },
  data() {
    return {
      selectedDateIndex: 0,
      selectTimeIndex: -1,
      preSelectedDateIndex: 0,
      preSelectTimeIndex: -1
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    selectDate(index) {
      if (index == this.selectedDateIndex) return
      if (this.$refs['timesRef']) {
        this.$refs['timesRef'].scrollTop = 0
      }
      if (this.preSelectTimeIndex != -1 && index == this.preSelectedDateIndex) {
        this.selectedDateIndex = this.preSelectedDateIndex
        this.selectTimeIndex = this.preSelectTimeIndex
        this.preSelectedDateIndex = 0
        this.preSelectTimeIndex = -1
        return
      }
      if (this.preSelectTimeIndex == -1 && this.selectTimeIndex != -1) {
        this.preSelectedDateIndex = this.selectedDateIndex
        this.preSelectTimeIndex = this.selectTimeIndex
      }
      this.selectedDateIndex = index
      this.selectTimeIndex = -1
    },
    selectTime(time, j_index) {
      this.selectTimeIndex = j_index

      this.$emit('select', {
        selected: `${this.dates[this.selectedDateIndex].doorDate} ${time.startTime},${
          this.dates[this.selectedDateIndex].doorDate
        } ${time.endTime}`
      })
      this.$emit('close')
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.date-time-selector {
  background: #fff;

  &.custom-dark {
    @include bgColor(#fff, $dark_bg_color);

    .date-columns {
      @include bgColor(#f2f3f4, rgba(255, 255, 255, 0.1));
    }
    .date-item {
      .label {
        @include fontColor(#000, rgba(255, 255, 255, 0.9));
      }
      .date {
        @include fontColor(#888888, rgba(255, 255, 255, 0.5));
      }
      &.active {
        @include bgColor(#fff, $dark_bg_color);
      }
    }
  }
}
.date-time-selector {
  height: 100%;
  width: 100%;
  display: flex;
}
.date-columns {
  width: 360px;
  background: #f2f3f4;
  overflow-x: hidden;
  overflow-y: auto;
}
.time-columns {
  width: calc(100% - 361px);
  overflow-x: hidden;
  overflow-y: auto;
}
.date-item {
  width: 100%;
  height: 255px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .label {
    color: #000;
    font-size: 45px;
    line-height: 57px;
    @include os-font-weight(45, 40);
    margin-bottom: 12px;
  }
  .date {
    color: #888;
    font-size: 36px;
    @include os-font-weight(36, 40);
  }
  &.active {
    background: #fff;
  }
}
.time-item {
  padding: 46px 84px 46px 90px;
  box-sizing: border-box;
  font-size: 42px;
  line-height: 57px;
  @include os-font-weight-number(42, 40);
  display: flex;
  justify-content: space-between;
  .checkbox {
    width: 54px;
    height: 54px;
  }
}
</style>
